import {
  IPostTravelAllowanceMod,
  IPostEmiLmoMod,
  IPostEndDate,
  IPostLodging,
  IPostMinReqHrs,
  IPostPayRate,
  IPostReimbursement,
  IPostTimeOff,
  IUpdateShift,
  IPostFurniture,
  iPostInsuranceMod,
  IPostBonusMod,
  IPostPayrollShiftDifferential,
  IPostPreferenceMod,
  IAdults,
  IChildren,
  IPostPTOMod,
  IUpdateOGP,
  IPostHousingMod,
  IPostBillingShiftDifferential,
} from 'app/models/Placement/PlacementMods';
import {
  bonusApprovedMethodOption,
  bonusBillingTypeOption,
  bonusPaymentTypeOption,
  bonusShortHourTypeOption,
  bonusTypeOption,
  endingTravelPayerOption,
  findKeyBaseOnValue,
  ptoOption,
} from '../ModificationsUtils';
import moment, { isMoment } from 'moment';

export const postMinReqHrs = (placementId, formData, selectedButton, userId, currentModDetails) => {
  const payload: IPostMinReqHrs = {
    placementId: placementId,
    travelerOptionId: currentModDetails?.travelerOptionId === null ? 0 : currentModDetails?.travelerOptionId,
    approvalStatusId: selectedButton.approvedStatus,
    acceptanceStatusId: selectedButton.acceptedStatus,
    effectiveDate: selectedButton.effectiveDate,
    userId: userId,
    voidStatus: selectedButton.isVoid,
    timestamp: currentModDetails?.timestamp,
    placementTimestamp: currentModDetails?.placementTimestamp,
    travelerOptionTimestamp: currentModDetails?.travelerOptionTimestamp,
    assignTaskId: currentModDetails?.assignTaskId,
    minReqHours: parseFloat(formData.minReqHours),
    minReqShifts: parseInt(formData.minReqShifts, 10),
  };
  return payload;
};

export const postPayRate = (placementId, formData, selectedButton, userId, currentModDetails, gwwExceptionsTypes) => {
  const payload: IPostPayRate = {
    placementId: placementId,
    travelerOptionId: currentModDetails?.travelerOptionId === null ? 0 : currentModDetails?.travelerOptionId,
    voidStatus: selectedButton.isVoid,
    assignRootTaskId: currentModDetails?.assignTaskId,
    assignTaskId: currentModDetails?.assignTaskId,
    timestamp: currentModDetails?.timestamp,
    placementTimestamp: currentModDetails?.placementTimestamp,
    travelerOptionTimestamp: currentModDetails?.travelerOptionTimestamp,
    regularRate: formData.regularRate ? parseFloat(formData.regularRate) : null,
    overtimeFactor: formData.overtimeFactor? parseFloat(formData.overtimeFactor) : 0,
    doubletimeFactor: formData.doubleTimeFactor ? parseFloat(formData.doubleTimeFactor) : null,
    holidayFactor: formData.holidayFactor ? parseFloat(formData.holidayFactor) : 0,
    onCallRate: formData.onCallRate ? parseFloat(formData.onCallRate) : null,
    callbackFactor: formData.callBackFactor ? parseFloat(formData.callBackFactor) : null,
    chargePremium: formData.chargePremium ? parseFloat(formData.chargePremium) : null,
    preceptorRate: formData.preceptorRate ? parseFloat(formData.preceptorRate) : null,
    payRoll: formData.payRoll,
    amountPerMile: formData.amountPerMile ? parseFloat(formData.amountPerMile) : null,
    paysGww: formData.paysGww,
    tempRate: formData.tempRate,
    additionalPremiumPay: formData.additionalPremiumPay,
    gwwExceptions: formData.gwwExceptions
      ? gwwExceptionsTypes
          .filter(item => formData.gwwExceptions.includes(item.description))
          ?.map(item => parseInt(item.id))
      : [],
    showUpAmount: formData.showUpAmount !== '' && formData.showUpAmount != null ? parseFloat(formData.showUpAmount) : null,
    showUpFactor: formData.showUpFactor !== '' && formData.showUpFactor != null ? parseFloat(formData.showUpFactor) : null,
    cancellationAmount: formData.cancellationAmount !== '' && formData.cancellationAmount != null ? parseFloat(formData.cancellationAmount) : null,
    cancellationFactor: formData.cancellationFactor !== '' && formData.cancellationFactor != null ? parseFloat(formData.cancellationFactor) : null,
    approvalStatusId: selectedButton.approvedStatus,
    acceptanceStatusId: selectedButton.acceptedStatus,
    effectiveDate: selectedButton.effectiveDate,
    userId: userId,
  };

  return payload;
};

export const postLodging = (placementId, formData, selectedButton, userId, currentModDetails) => {
  const payload: IPostLodging = {
    placementId: placementId,
    travelerOptionId: currentModDetails?.travelerOptionId === null ? 0 : currentModDetails?.travelerOptionId,
    uhBenefit: parseFloat(formData.lodgingPerDiemAdjustment),
    daily: formData.dailyLodging,
    acceptanceStatusId: selectedButton.acceptedStatus,
    approvalStatusId: selectedButton.approvedStatus,
    userId: userId,
    effectiveDate: selectedButton.effectiveDate,
    timestamp: currentModDetails?.timestamp,
    placementTimestamp: currentModDetails?.placementTimestamp,
    travelerOptionTimestamp: currentModDetails?.travelerOptionTimestamp,
    voidStatus: selectedButton.isVoid,
    assignTaskId: currentModDetails?.assignTaskId,
  };
  return payload;
};

export const postStartDate = (placementId, formData, selectedButton, userId, currentModDetails) => {
  const payload = {
    placementId: placementId,
    travelerOptionId: currentModDetails?.travelerOptionId === null ? 0 : currentModDetails?.travelerOptionId,
    startDate: formData?.newStartDate,
    keepConstant:
      formData?.keepConstant === 'true' ? true : formData?.keepConstant === 'false' ? false : formData?.keepConstant,
    initiatedByUserId: formData?.initiatedByUserId ? formData?.initiatedByUserId : null,
    preEmploymentDate: formData?.newPreEmploymentDate,
    reasonCodeId: formData?.startDateReasonCodeId ? formData?.startDateReasonCodeId : null,
    acceptanceStatusId: selectedButton.acceptedStatus,
    approvalStatusId: selectedButton.approvedStatus,
    userId: userId,
    effectiveDate: selectedButton.effectiveDate,
    timestamp: currentModDetails?.timestamp,
    travelerOptionTimestamp: currentModDetails?.travelerOptionTimestamp,
    placementTimestamp: currentModDetails?.placementTimestamp,
    voidStatus: selectedButton.isVoid,
    assignRootTaskId: currentModDetails?.assignRootTaskId,
    assignTaskId: currentModDetails?.assignTaskId,
  };
  return payload;
};

export const postEndDate = (placementId, formData, selectedButton, userId, currentModDetails) => {
  const payload: IPostEndDate = {
    placementId: placementId,
    travelerOptionId: currentModDetails?.travelerOptionId === null ? 0 : currentModDetails?.travelerOptionId,
    endDate: formData.newEndDate,
    acceptanceStatusId: selectedButton.acceptedStatus,
    approvalStatusId: selectedButton.approvedStatus,
    userId: userId,
    effectiveDate: selectedButton.effectiveDate,
    timestamp: currentModDetails?.timestamp,
    placementTimestamp: currentModDetails?.placementTimestamp,
    travelerOptionTimestamp: currentModDetails?.travelerOptionTimestamp,
    voidStatus: selectedButton.isVoid,
    assignTaskId: currentModDetails?.assignTaskId,
    initiatedByUserId: formData?.initiatedByUserId,
    assignRootTaskId: currentModDetails?.assignRootTaskId,
  };
  return payload;
};

export const postReimbursement = (
  placementId,
  formData,
  selectedButton,
  userId,
  currentModDetails,
  reimbursementCategoryAndFrequency,
) => {
  const payload: IPostReimbursement = {
    placementId: placementId,
    travelerOptionId: currentModDetails?.travelerOptionId === null ? 0 : currentModDetails?.travelerOptionId,
    endDate: formData?.initialEndDate,
    acceptanceStatusId: selectedButton.acceptedStatus,
    approvalStatusId: selectedButton.approvedStatus,
    userId: userId,
    effectiveDate: selectedButton.effectiveDate,
    timestamp: currentModDetails?.timestamp,
    placementTimestamp: currentModDetails?.placementTimestamp,
    travelerOptionTimestamp: currentModDetails?.travelerOptionTimestamp,
    voidStatus: selectedButton.isVoid,
    assignRootTaskId: currentModDetails?.assignRootTaskId,
    assignTaskId: currentModDetails?.assignTaskId,
    reimbursementFrequencyTypeId: formData.reimbursementFrequencyTypeId,
    reimbursementCategoryDescriptionId: formData.reimbursementDescriptionId
      ? parseInt(formData.reimbursementDescriptionId)
      : null,
    billable: currentModDetails.billable,
    payeeId: parseInt(formData.payeeId.toString()),
    amountPerMile: formData.amountPerMile,
    reimbursementCategoryId: parseInt(formData.reimbursementCategoryId.toString()),
    reimbursementDescriptionId: parseInt(formData.reimbursementDescriptionId.toString()),
    amount: parseFloat(formData.amount.toString()),
    requiresReceipts: formData.requiresReceipts
      ? formData.requiresReceipts.toString() === 'true'
        ? true
        : false
      : false,
    description: formData.description,
  };
  return payload;
};

export const postTravelAllowance = (
  placementId,
  formData,
  selectedButton,
  userId,
  currentModDetails,
  travelerOptionTypeId,
  selectedModType,
) => {
  const payload: IPostTravelAllowanceMod = {
    placementId: placementId,
    approvalStatusId: selectedButton.approvedStatus,
    acceptanceStatusId: selectedButton.acceptedStatus,
    userId: userId,
    travelerOptionId: currentModDetails?.travelerOptionId === null ? 0 : currentModDetails?.travelerOptionId,
    assignRootTaskId: currentModDetails?.assignRootTaskId,
    assignTaskId: currentModDetails?.assignTaskId,
    voidStatus: selectedButton.isVoid,
    timestamp: currentModDetails?.placementTravelAllowanceTimeStamp
      ? currentModDetails?.placementTravelAllowanceTimeStamp
      : currentModDetails?.timestamp,
    travelerOptionTimestamp: currentModDetails?.travelerOptionTimestamp,
    placementTimestamp: currentModDetails?.placementTimestamp,
    payerId: formData.payerId,
    payeeId: formData.payeeId,
    amountPerMile: parseFloat(formData.amountPerMile),
    allowanceCap: parseFloat(formData.allowanceCap),
    billable: formData.billable,
    travelerOptionTypeId: travelerOptionTypeId,
    effectiveDate: selectedButton.effectiveDate,
    timeOffRequests: formData.timeOffRequests,
    selectedModType: selectedModType,
  };
  return payload;
};

export const postShift = (placementId, formData, selectedButton, userId, currentModDetails) => {
  const payload: IUpdateShift = {
    placementId: placementId,
    travelerOptionId: currentModDetails?.travelerOptionId === null ? 0 : currentModDetails?.travelerOptionId,
    shiftId: formData.shiftId ?? currentModDetails?.shiftId,
    acceptanceStatusId: selectedButton.acceptedStatus,
    approvalStatusId: selectedButton.approvedStatus,
    userId: userId,
    effectiveDate: selectedButton.effectiveDate,
    timestamp: currentModDetails?.timeStamp,
    placementTimestamp: currentModDetails?.placementTimestamp,
    travelerOptionTimestamp: currentModDetails?.travelerOptionTimestamp,
    voidStatus: selectedButton.isVoid,
    assignTaskId: currentModDetails?.assignTaskId,
    assignRootTaskId: currentModDetails?.assignRootTaskId,
  };
  return payload;
};

export const postTimeOff = (placementId, timeOffEditRequests, selectedButton, userId, currentModDetails) => {
  const payload: IPostTimeOff = {
    placementId: placementId,
    travelerOptionId: currentModDetails?.travelerOptionId === null ? 0 : currentModDetails?.travelerOptionId,
    acceptanceStatusId: selectedButton.acceptedStatus,
    approvalStatusId: selectedButton.approvedStatus,
    userId: userId,
    effectiveDate: selectedButton.effectiveDate,
    timestamp: currentModDetails?.timestamp,
    placementTimestamp: currentModDetails?.placementTimeStamp,
    travelerOptionTimestamp: currentModDetails?.travelerOptionTimestamp,
    voidStatus: selectedButton.isVoid,
    assignRootTaskId: currentModDetails?.assignRootTaskId,
    assignTaskId: currentModDetails?.assignTaskId,
    timeOffRequests: getTimeOffRequests(placementId, timeOffEditRequests, selectedButton, userId, currentModDetails),
  };
  return payload;
};
export const postPreference = (placementId, preferenceModEditRequests, selectedButton, userId, currentModDetails) => {
  const adults: IAdults[] = getFormatedDetails(
    preferenceModEditRequests.adultsDetails,
    currentModDetails?.travelerInfo?.adults,
  );
  const children: IChildren[] = getFormatedDetails(
    preferenceModEditRequests.childrenDetails,
    currentModDetails?.travelerInfo?.children,
  );
  const pets = getFormatedDetails(preferenceModEditRequests.petsDetails, currentModDetails?.travelerInfo?.pets);
  pets.forEach(pet => {
    if (pet.weight === '' || pet.weight === undefined) {
      pet.weight = null;
    }
  });
  const payload: IPostPreferenceMod = {
    placementId: placementId,
    travelerOptionId: currentModDetails?.travelerOptionId === null ? 0 : currentModDetails?.travelerOptionId,
    acceptanceStatusId: selectedButton.acceptedStatus,
    approvalStatusId: selectedButton.approvedStatus,
    userId: userId,
    effectiveDate: selectedButton.effectiveDate,
    timestamp: currentModDetails?.timestamp,
    placementTimestamp: currentModDetails?.placementTimestamp,
    travelerOptionTimestamp: currentModDetails?.travelerOptionTimestamp,
    voidStatus: selectedButton.isVoid,
    assignRootTaskId: currentModDetails?.assignRootTaskId,
    assignTaskId: currentModDetails?.assignTaskId,
    adults,
    children,
    pets,
  };
  return payload;
};
export const postPTOMod = (placementId, formData, selectedButton, userId, currentModDetails) => {
  const selectedOption = findKeyBaseOnValue(ptoOption, formData.ptoPlanDescription);

  const payload: IPostPTOMod = {
    placementId: placementId,
    travelerOptionId: currentModDetails?.travelerOptionId === null ? 0 : currentModDetails?.travelerOptionId,
    acceptanceStatusId: selectedButton.acceptedStatus,
    approvalStatusId: selectedButton.approvedStatus,
    userId: userId,
    effectiveDate: selectedButton.effectiveDate,
    timestamp: currentModDetails?.ptoTimeStamp,
    placementTimestamp: currentModDetails?.placementTimestamp,
    travelerOptionTimestamp: currentModDetails?.travelerOptionTimestamp,
    voidStatus: selectedButton.isVoid,
    assignRootTaskId: currentModDetails?.assignRootTaskId,
    assignTaskId: currentModDetails?.assignTaskId,
    ptoPlanID: selectedOption.ID,
  };
  return payload;
};

export const postFurniture = (
  placementId,
  formData,
  selectedButton,
  userId,
  currentModDetails,
  furnitureEditRequests,
  utilityEditRequests,
) => {
  const payload: IPostFurniture = {
    billable: currentModDetails?.billable,
    utilityNotes: formData?.utilityNotes ? formData?.utilityNotes : '',
    furnitureNotes: formData?.furnitureNotes ? formData?.furnitureNotes : '',
    placementId: placementId,
    timestamp: currentModDetails?.timestamp,
    placementTimestamp: currentModDetails?.placementTimestamp,
    travelerOptionTimestamp: currentModDetails?.travelerOptionTimestamp,
    travelerOptionId: currentModDetails?.travelerOptionId === null ? 0 : currentModDetails?.travelerOptionId,
    acceptanceStatusId: selectedButton.acceptedStatus,
    approvalStatusId: selectedButton.approvedStatus,
    voidStatus: selectedButton.isVoid,
    assignRootTaskId: currentModDetails?.assignRootTaskId,
    assignTaskId: currentModDetails?.assignTaskId,
    userId: userId,
    effectiveDate: selectedButton.effectiveDate,
    furniture: getFurnitureRequests(placementId, furnitureEditRequests, currentModDetails),
    utilities: getUtilitiesRequests(placementId, utilityEditRequests, currentModDetails),
  };
  return payload;
};
export const postPayrollShiftDifferential = (
  placementId,
  formData,
  payrollShiftRequests,
  selectedButton,
  userId,
  currentModDetails,
) => {
  const payload: IPostPayrollShiftDifferential = {
    placementId: placementId,
    travelerOptionId: currentModDetails?.travelerOptionId === null ? 0 : currentModDetails?.travelerOptionId,
    shiftDifferentialTemplateTypeId: formData.shiftDifferentialTemplateTypeId
      ? parseInt(formData.shiftDifferentialTemplateTypeId)
      : 0,
    acceptanceStatusId: selectedButton.acceptedStatus,
    approvalStatusId: selectedButton.approvedStatus,
    userId: userId,
    effectiveDate: selectedButton.effectiveDate,
    timestamp: currentModDetails?.timestamp,
    placementTimestamp: currentModDetails?.placementTimestamp,
    travelerOptionTimestamp: currentModDetails?.travelerOptionTimestamp,
    voidStatus: selectedButton.isVoid,
    assignRootTaskId: currentModDetails?.assignRootTaskId,
    assignTaskId: currentModDetails?.assignTaskId,
    shiftDifferentials: getPayrollShiftDifferentialRequests(
      placementId,
      payrollShiftRequests,
      selectedButton,
      userId,
      currentModDetails,
    ),
  };
  return payload;
};

const getFurnitureRequests = (placementId, furnitureEditRequests, currentModDetails) => {
  const requests: any[] = [];
  furnitureEditRequests?.map(t => {
    requests?.push({
      placementId: placementId,
      travelerOptionId: currentModDetails?.travelerOptionId === null ? 0 : currentModDetails?.travelerOptionId,
      placementFurnitureId: t.placementFurnitureId,
      furnitureCostId: t.furnitureCostId,
      include: t.include,
      description: t.description,
      standardCost: t.standardCost,
      costToTraveler: t.costToTraveler,
      quantity: t.quantity,
      placementTimestamp: t.placementTimestamp,
    });
  });
  return requests;
};

const getUtilitiesRequests = (placementId, utilityEditRequests, currentModDetails) => {
  const requests: any[] = [];
  utilityEditRequests?.map(t => {
    requests?.push({
      placementId: placementId,
      travelerOptionId: currentModDetails?.travelerOptionId === null ? 0 : currentModDetails?.travelerOptionId,
      placementUtilityId: t.placementUtilityId,
      utilityCostId: t.utilityCostId,
      include: t.include,
      description: t.description,
      standardCost: t.standardCost,
      costToTraveler: t.costToTraveler,
      billable: t.billable,
      placementTimestamp: t.placementTimestamp,
    });
  });
  return requests;
};

const getTimeOffRequests = (placementId, timeOffEditRequests, selectedButton, userId, currentModDetails) => {
  const requests: any[] = [];
  timeOffEditRequests.map(t => {
    requests.push({
      placementId: placementId,
      travelerOptionId: currentModDetails?.travelerOptionId === null ? 0 : currentModDetails?.travelerOptionId,
      placementTimeOffId: t.placementTimeOffId,
      startDate: t.startDate,
      endDate: t.endDate,
      days: t.days ? t.days : null,
      hours: t.hours,
      cost: t.cost ? t.cost : null,
      placementTimeOffPayerId: t.placementTimeOffPayerId ? t.placementTimeOffPayerId : null,
      isModified: t.isModified,
      timestamp: t.timestamp,
      facilityApprovedBy: t.facilityApprovedBy ? t.facilityApprovedBy : null,
      interimPlacementId: t.interimPlacementId,
      interimTravelerOptionId: t.interimTravelerOptionId,
      timeOffPayerDescription: t.timeOffPayerDescription,
      placementTimeStamp: t.placementTimeStamp,
      approvalStatusId: t.approvalStatusId,
      voidStatus: t.voidStatus,
      assigned: t.assigned,
    });
  });
  return requests;
};

const getPayrollShiftDifferentialRequests = (
  placementId,
  payrollShiftRequests,
  selectedButton,
  userId,
  currentModDetails,
) => {
  const requests: any[] = [];
  payrollShiftRequests.map(ps => {
    requests.push({
      placementId: placementId,
      travelerOptionId: currentModDetails?.travelerOptionId === null ? 0 : currentModDetails?.travelerOptionId,
      shiftDifferentialId: ps.shiftDifferentialId,
      shiftDifferentialTypeId: ps.shiftDifferentialTypeId,
      shiftDifferentialDescriptionTypeId: ps.shiftDifferentialDescriptionTypeId,
      startTime: ps.startTime,
      endTime: ps.endTime,
      amount: ps.amount,
      monday: ps.monday,
      tuesday: ps.tuesday,
      wednesday: ps.wednesday,
      thursday: ps.thursday,
      friday: ps.friday,
      saturday: ps.saturday,
      sunday: ps.sunday,
      timestamp: ps.timestamp,
      placementTimestamp: ps.placementTimestamp,
      approvalStatusId: ps.approvalStatusId,
    });
  });
  return requests;
};
export const postEmiLmo = (placementId, formData, selectedButton, userId, currentModDetails) => {
  const payload: IPostEmiLmoMod = {
    placementId: placementId,
    approvalStatusId: selectedButton.approvedStatus,
    acceptanceStatusId: selectedButton.acceptedStatus,
    userId: userId,
    travelerOptionId: currentModDetails?.travelerOptionId === null ? 0 : currentModDetails?.travelerOptionId,
    assignRootTaskId: currentModDetails?.assignRootTaskId,
    assignTaskId: currentModDetails?.assignTaskId,
    voidStatus: selectedButton.isVoid,
    timestamp: currentModDetails?.timestamp,
    travelerOptionTimestamp: currentModDetails?.travelerOptionTimestamp,
    placementTimestamp: currentModDetails?.placementTimestamp,
    effectiveDate: selectedButton.effectiveDate,
    emiCostPerDay: formData.emiCostPerDay !== '' ? formData.emiCostPerDay : null,
    emiDaysWaived: formData.emiDaysWaived !== '' ? formData.emiDaysWaived : null,
    emiNumberOfDays: formData.emiNumberOfDays !== '' ? formData.emiNumberOfDays : null,
    lmoCostPerDay: formData.lmoCostPerDay !== '' ? formData.lmoCostPerDay : null,
    lmoDaysWaived: formData.lmoDaysWaived !== '' ? formData.lmoDaysWaived : null,
    lmoNumberOfDays: formData.lmoNumberOfDays !== '' ? formData.lmoNumberOfDays : null,
    earlyMoveInDate: formData.earlyMoveInDate,
    lateMoveOutDate: formData.lateMoveOutDate,
    moveInDate: currentModDetails.moveInDate,
    moveOutDate: currentModDetails.moveOutDate,
    placementStartDate: formData?.placementStartDate,
    placementEndDate: formData?.placementEndDate,
  };
  return payload;
};

export const postBonus = (placementId, formData, selectedButton, userId, currentModDetails) => {
  const payload: IPostBonusMod = {
    placementId: placementId,
    approvalStatusId: selectedButton.approvedStatus,
    acceptanceStatusId: selectedButton.acceptedStatus,
    userId: userId,
    travelerOptionId: currentModDetails?.travelerOptionId === null ? 0 : currentModDetails?.travelerOptionId,
    assignRootTaskId: currentModDetails?.assignRootTaskId,
    assignTaskId: currentModDetails?.assignTaskId,
    voidStatus: selectedButton.isVoid,
    timestamp: currentModDetails?.placementBonusTimestamp,
    travelerOptionTimestamp: currentModDetails?.travelerOptionTimestamp,
    placementTimestamp: currentModDetails?.placementTimestamp,
    effectiveDate: selectedButton.effectiveDate,
    approvalDate: formData.approvalDate?.startDate ?? formData.approvalDate ? moment(formData.approvalDate)?.startOf('day')?.format('YYYY-MM-DDTHH:mm:ss') : formData.approvalDate,
    approvalTypeId: formData.approvalMethod
      ? bonusApprovedMethodOption.find(b => b.Description === formData.approvalMethod).Id
      : null,
    approvedBy: formData.approvedBy,
    billingAmount: parseFloat(formData.billingAmount),
    billingTypeId: formData.billingType
      ? bonusBillingTypeOption.find(b => b.Description === formData.billingType).Id
      : null,
    bonusAmount: parseFloat(formData.bonusAmount),
    bonusId: currentModDetails.bonusId,
    bonusPaid: formData.bonusPaid ? 'Y' : 'N',
    bonusShortHoursTypeId: formData.shortHoursType
      ? bonusShortHourTypeOption.find(b => b.Description === formData.shortHoursType).Id
      : null,
    bonusTypeId: formData.bonusType ? bonusTypeOption.find(b => b.Description === formData.bonusType).Id : null,
    dateDue: formData.dateDue,
    startDate: formData.startDate,
    endDate: formData.endDate,
    forfeitBonus: formData.forfeitBonus,
    notes: formData.notes,
    payerId: formData.payer ? endingTravelPayerOption.find(b => b.Description === formData.payer).Id : null,
    paymentTypeId: formData.paymentType
      ? bonusPaymentTypeOption.find(b => b.Description === formData.paymentType).Id
      : null,
    requiredHours: formData.requiredHours === '' ? null : formData.requiredHours,
    shortAssignmentBonusId:
      currentModDetails.shortAssignmentBonusId === 0 ? 3 : currentModDetails.shortAssignmentBonusId,
    updateOptionStatus: currentModDetails.updateOptionStatus,
  };
  return payload;
};

export const postInsurance = (placementId, formData, selectedButton, userId, currentModDetails) => {
  const payload: iPostInsuranceMod = {
    placementId: placementId,
    travelerOptionId: currentModDetails?.travelerOptionId === null ? 0 : currentModDetails?.travelerOptionId,
    effectiveDateTypeId: formData.effectiveDateTypeId,
    placementInsuranceTypeId: formData?.insuranceTypeId,
    amount: parseFloat(formData.insuranceAmount),
    insuranceEffectiveDate: formData?.insuranceCustomDate,
    acceptanceStatusId: selectedButton.acceptedStatus,
    approvalStatusId: selectedButton.approvedStatus,
    userId: userId,
    effectiveDate: selectedButton.effectiveDate,
    insuranceProviderId: currentModDetails?.insuranceProviderId,
    timestamp: currentModDetails?.timestamp,
    travelerOptionTimestamp: currentModDetails?.travelerOptionTimestamp,
    placementTimestamp: currentModDetails?.placementTimestamp,
    voidStatus: selectedButton.isVoid,
    assignRootTaskId: currentModDetails?.assignTaskId,
    assignTaskId: currentModDetails?.assignTaskId,
  };
  return payload;
};
export const postBillRate = (
  placementId,
  formData,
  selectedButton,
  userId,
  currentModDetails,
  gwwExceptionsTypes,
  pricingReasons,
) => {
  const payload = {
    placementId: placementId,
    regularRate: formData.regularRate ? parseFloat(formData.regularRate) : null,
    gww: formData.billRateGwwRate ? parseFloat(formData.billRateGwwRate) : null,
    overtimeRate: formData.overtimeRate ? parseFloat(formData.overtimeRate) : null,
    doubleTimeRate: formData.doubleTimeRate ? parseFloat(formData.doubleTimeRate) : null,
    holidayFactor: formData.holidayFactor ? parseFloat(formData.holidayFactor) : null,
    onCallRate: formData.onCallRate ? parseFloat(formData.onCallRate) : null,
    callbackFactor: formData.callBackFactor ? parseFloat(formData.callBackFactor) : null,
    chargePremium: formData.chargePremium ? parseFloat(formData.chargePremium) : null,
    preceptorRate: formData.preceptorRate ? parseFloat(formData.preceptorRate) : null,
    billRateFlat: formData.billRateFlat ? parseFloat(formData.billRateFlat) : null,
    billRateHourly: formData.billRateHourly ? parseFloat(formData.billRateHourly) : null,
    contractTypeId: formData.contractTypeId,
    overtimeFactor: formData.overtimeFactor ? parseFloat(formData.overtimeFactor) : null,
    doubletimeFactor: formData.doubleTimeFactor ? parseFloat(formData.doubleTimeFactor) : null,
    holidayRate: formData.holidayRate ? parseFloat(formData.holidayRate) : null,
    callbackRate: formData.callbackRate ? parseFloat(formData.callbackRate) : null,
    premiumPricingDiff: formData.premiumPricingDiff ? parseFloat(formData.premiumPricingDiff) : null,
    amountPerMile: formData.amountPerMile ? parseFloat(formData.amountPerMile) : null,
    adminFee: formData.adminFee ? parseFloat(formData.adminFee) : null,
    orientationRate: formData.orientationRate ? parseFloat(formData.orientationRate) : null,
    orientationFactor: formData.orientationFactor ? parseFloat(formData.orientationFactor) : null,
    lunchPenalty: formData.lunchPenalty ? parseFloat(formData.lunchPenalty) : null,
    shiftId: formData.shiftId ? parseFloat(formData.shiftId) : null,
    hoursPerPayCycle: formData.billRateMinReqHours ? parseFloat(formData.billRateMinReqHours) : null,
    cancellationHoursAllowed: formData.cancelledHours ? parseFloat(formData.cancelledHours) : null,
    cancellationHoursFrequencyId: formData.cancellationHoursFrequencyId,
    gwwExceptions: formData.gwwExceptions
      ? gwwExceptionsTypes
          .filter(item => formData.gwwExceptions.includes(item.description))
          ?.map(item => parseInt(item.id))
      : [],
    gwwExceptionNotes: formData.gwwExceptionNotes,
    showUpAmount: formData.showUpAmount !== '' && formData.showUpAmount != null ? parseFloat(formData.showUpAmount) : null,
    showUpFactor: formData.showUpFactor !== '' && formData.showUpFactor != null ? parseFloat(formData.showUpFactor) : null,
    cancellationAmount: formData.cancellationAmount !== '' && formData.cancellationAmount != null ? parseFloat(formData.cancellationAmount) : null,
    cancellationFactor: formData.cancellationFactor !== '' && formData.cancellationFactor != null ? parseFloat(formData.cancellationFactor) : null,
    premiumPricingReasons: formData.premiumPricingReasons
      ? pricingReasons
          .filter(item => formData.premiumPricingReasons.includes(item.Description))
          .map(item => parseInt(item.Id))
      : [],
    travelerOptionId: currentModDetails?.travelerOptionId === null ? 0 : currentModDetails?.travelerOptionId,
    approvalStatusId: selectedButton.approvedStatus,
    acceptanceStatusId: selectedButton.acceptedStatus,
    effectiveDate: selectedButton.effectiveDate,
    userId: userId,
    voidStatus: selectedButton.isVoid,
    timestamp: currentModDetails?.timestamp,
    placementTimestamp: currentModDetails?.placementTimestamp,
    travelerOptionTimestamp: currentModDetails?.travelerOptionTimestamp,
    assignRootTaskId: currentModDetails?.assignRootTaskId,
    assignTaskId: currentModDetails?.assignTaskId,
  };
  return payload;
};

export const postOGPLoan = (placementId, formData, selectedButton, userId, currentModDetails) => {
  const payload: IUpdateOGP = {
    placementId: placementId,
    travelerOptionId: currentModDetails?.travelerOptionId === null ? 0 : currentModDetails?.travelerOptionId,
    totalAmount: formData?.totalAmount,
    perCheckAmount: formData?.perCheckAmount,
    startDate: formData?.startDate,
    totalAdminFee: parseFloat(formData?.totalAdminFee) ? formData?.totalAdminFee : null,
    perCheckAdminFee: parseFloat(formData?.perCheckAdminFee) ? formData?.perCheckAdminFee : null,
    feeStartDate: formData?.feeStartDate !== '' ? formData?.feeStartDate : null,
    acceptanceStatusId: selectedButton.acceptedStatus,
    approvalStatusId: selectedButton.approvedStatus,
    userId: userId,
    effectiveDate: selectedButton.effectiveDate,
    timestamp: currentModDetails?.timestamp,
    placementTimestamp: currentModDetails?.placementTimestamp,
    travelerOptionTimestamp: currentModDetails?.travelerOptionTimestamp,
    voidStatus: selectedButton.isVoid,
    assignTaskId: currentModDetails?.assignTaskId,
    assignRootTaskId: currentModDetails?.assignRootTaskId,
  };
  return payload;
};

export const postBillingShiftDifferential = (
  placementId,
  formData,
  billingShiftRequests,
  selectedButton,
  userId,
  currentModDetails,
) => {
  const payload: IPostBillingShiftDifferential = {
    placementId: placementId,
    travelerOptionId: currentModDetails?.travelerOptionId === null ? 0 : currentModDetails?.travelerOptionId,
    shiftDifferentialTemplateTypeId: formData.shiftDifferentialTemplateTypeId
      ? parseInt(formData.shiftDifferentialTemplateTypeId)
      : 0,
    acceptanceStatusId: selectedButton.acceptedStatus,
    approvalStatusId: selectedButton.approvedStatus,
    userId: userId,
    effectiveDate: selectedButton.effectiveDate,
    timestamp: currentModDetails?.timestamp,
    placementTimestamp: currentModDetails?.placementTimestamp,
    travelerOptionTimestamp: currentModDetails?.travelerOptionTimestamp,
    voidStatus: selectedButton.isVoid,
    assignRootTaskId: currentModDetails?.assignRootTaskId,
    assignTaskId: currentModDetails?.assignTaskId,
    shiftDifferentials: getBillingShiftDifferentialRequests(placementId, billingShiftRequests, currentModDetails),
  };
  return payload;
};

const getBillingShiftDifferentialRequests = (placementId, billingShiftRequests, currentModDetails) => {
  const requests: any[] = [];
  billingShiftRequests.map(ps => {
    requests.push({
      placementId: placementId,
      travelerOptionId: currentModDetails?.travelerOptionId === null ? 0 : currentModDetails?.travelerOptionId,
      shiftDifferentialId: ps.shiftDifferentialId,
      shiftDifferentialTypeId: ps.shiftDifferentialTypeId,
      shiftDifferentialDescriptionTypeId: ps.shiftDifferentialDescriptionTypeId,
      startTime: ps.startTime,
      endTime: ps.endTime,
      amount: ps.amount,
      monday: ps.monday,
      tuesday: ps.tuesday,
      wednesday: ps.wednesday,
      thursday: ps.thursday,
      friday: ps.friday,
      saturday: ps.saturday,
      sunday: ps.sunday,
      timestamp: ps.timestamp,
      placementTimestamp: ps.placementTimestamp,
      approvalStatusId: ps.approvalStatusId,
    });
  });
  return requests;
};

// Find the new element in the updated array and set its id to zero
const getFormatedDetails = (updatedArray = [], originalArray = []) => {
  return updatedArray.map(item => ({
    ...item,
    id: item.id <= 0 || !originalArray.some(originalItem => originalItem.id === item.id) ? 0 : item.id,
  }));
};

export const postHousing = (placementId, formData, selectedButton, userId, currentModDetails) => {
  const payload: IPostHousingMod = {
    placementId: placementId,
    approvalStatusId: selectedButton.approvedStatus,
    acceptanceStatusId: selectedButton.acceptedStatus,
    effectiveDate: selectedButton.effectiveDate,
    userId: userId,
    travelerOptionId: currentModDetails?.travelerOptionId === null ? 0 : currentModDetails?.travelerOptionId,
    assignRootTaskId: currentModDetails?.assignRootTaskId,
    assignTaskId: currentModDetails?.assignTaskId,
    voidStatus: selectedButton.isVoid,
    timestamp: currentModDetails?.timestamp,
    travelerOptionTimestamp: currentModDetails?.travelerOptionTimestamp,
    placementTimestamp: currentModDetails.placementTimestamp,
    housingProviderId: formData.housingProviderId,
    housingProvider: formData.housingProvider,
    standardAmount: parseFloat(formData.standardAmountCharged),
    requestedHousingId: formData.travelerRequestedHousingTypeId,
    travelerRequestedHousingType: formData.travelerRequestedHousingType,
    amountChargedToTraveler: parseFloat(formData.amountToTraveler),
    actualHousingType: formData.actualHousingType,
    housingDescriptionId: formData.actualHousingTypeId,
    reasonForChange: formData.reasonForChange,
    privateHousingOptionTypeId: formData.reasonForChangeId,
    monthlyLodgingAmount: formData.monthlyLodgingAmount,
    billableToClient: currentModDetails.billableToClient,
    petRentCharge: parseFloat(formData.petRentCharge),
    parkingGarageCharge: parseFloat(formData.parkingGarageCharge),
    utilityCharge: parseFloat(formData.utilityCharge),
    otherDepositNotes: formData.otherDepositDescription,
    deposits: formData.deposits,
  };
  return payload;
};
